import axios from "axios"
const url =process.env.REACT_APP_API_URL;



export const get = () => (dispatch) => {
    axios.get(`${url}/gemstone`).then((res) => {
        dispatch({
            type: 'Get-GEMSTONE',
            payload:  res.data,
        })
    })
}
export const getHorescope = () => (dispatch) => {
    axios.get(`${url}/horescope`).then((res) => {
        dispatch({
            type: 'Get-HORESCOPE',
            payload:  res.data,
        })
    })
}
export const getById = (id) => (dispatch) => {
    axios.get(`${url}/gemstone`).then((res) => {
        let data = res.data
        const result = data.filter(word => word.id==id);
        dispatch({
            type: 'Get-GEMSTONE',
            payload: result,
        })
    })
}
export const getImage = () => (dispatch) => {
    axios.get(`${url}/images`).then((res) => {
        //console.log(res.data)
        dispatch({
            type: 'Get-IMAGE',
            payload: res.data,
        })
    })
}
export const gethistory = (id) => (dispatch) => {
    axios.get(`${url}/history`).then((res) => {
        let data = res.data
      const result = data.filter(data => data.id==id);
        dispatch({
            type: 'Get-HISTORY',
            payload:  res.data,
        })
    })
}
export const getclassfiction = (id) => (dispatch) => {
    axios.get(`${url}/classfiction`).then((res) => {
      let data = res.data
      const result = data.filter(word => word.id==id);
      
        dispatch({
            type: 'Get-CLASSFICATION',
            payload: result,
        })
    })
}
export const getGenuinity = () => (dispatch) => {
    axios.get(`${url}/genuinity`).then((res) => {
      
        dispatch({
            type: 'Get-Genuinity',
            payload: res.data,
        })
    })
}
export const getAnniversary=() => (dispatch) => {
    axios.get(`${url}/anniversary`).then((res) => {
        dispatch({
            type: 'Get-Anniversary',
            payload: res.data,
        })
    })
}
export const getMarket = (id) => (dispatch) => {
    axios.get(`${url}/market`).then((res) => {
    
        dispatch({
            type: 'Get-Market',
            payload: res.data,
        })
    })
}

// export const insertTodos = ( data) => (dispatch) => {
//     axios
//         .post('http://localhost:5000/todos', {data })
//         .then((res) => {
//             dispatch({
//                 type: 'ADD-TODO',

//                 payload: res.data,

//             })
//             dispatch(getTodos())
//         })
// }
// export const deleteTodos = ( id,data) => (dispatch) => {
    
//     axios
//     .delete('http://localhost:5000/todos/'+id)
    
//         .then((res) => {
//             console.log(res)
//             dispatch({
//                 type: 'DELETE-TODO',

//                 payload: res.data,

//             })
//             dispatch(getTodos())
//         })
// }